module.exports = __webpack_public_path__ + "img/logo_jdm.d279f39d.png";